module.exports = __webpack_public_path__ + "img/logo-even.b5fc3163.webp";